export const benefits = [
  {
    icon: "ri-shield-check-line",
    title: "Niezależność",
    description: "Nie jestem przedstawicielem jednego banku – analizuję oferty wielu instytucji finansowych.",
  },
  {
    icon: "ri-file-search-line",
    title: "Analiza wielu ofert",
    description: "Porównuję warunki, oprocentowanie, prowizje i harmonogram spłat, by znaleźć najlepsze rozwiązanie.",
  },
  {
    icon: "ri-folder-zip-line",
    title: "Pomoc w dokumentach",
    description: "Wspieram w przygotowaniu i kompletowaniu całej dokumentacji wymaganej przez banki.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Lokalne wsparcie w Sanoku i na Podkarpaciu",
    description: "Obsługuję klientów z Sanoka, Brzozowa, Leska, Ustrzyk Dolnych, Dynowa, Bieszczad i całego Podkarpacia.",
  },
];

export const services = [
  {
    icon: "ri-home-smile-line",
    title: "Kredyty hipoteczne",
    description: "Finansowanie zakupu, budowy lub remontu nieruchomości – mieszkania, domy, działki. Pomagam wybrać najlepsze warunki wielu banków.",
    highlight: false,
  },
  {
    icon: "ri-coins-line",
    title: "Kredyty gotówkowe",
    description: "Szybkie kredyty na dowolny cel – remont, wyjazd, spłatę zobowiązań. Minimum formalności, konkurencyjne oprocentowanie.",
    highlight: false,
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Kredyty firmowe",
    description: "Finansowanie dla przedsiębiorców – inwestycje, rozwój, obrót. Kredyty obrotowe, inwestycyjne i leasing.",
    highlight: false,
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "Refinansowanie",
    description: "Przejście na korzystniejsze warunki spłaty kredytu hipotecznego. Niższa rata, krótszy okres – lepsze dopasowanie do sytuacji.",
    highlight: false,
  },
  {
    icon: "ri-hand-heart-line",
    title: "Analiza finansowa",
    description: "Kompleksowa analiza sytuacji finansowej, planowanie budżetu, optymalizacja zobowiązań i bezpieczne podejście do zadłużenia.",
    highlight: false,
  },
  {
    icon: "ri-umbrella-line",
    title: "Ubezpieczenia kredytowe",
    description: "Dobór odpowiedniego ubezpieczenia życia i zdrowia do kredytu – ochrona rodziny i spokojna spłata zobowiązań.",
    highlight: false,
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Bezpłatna konsultacja",
    description: "Poznaję Twoją sytuację, cele i oczekiwania. Rozmowa może odbyć się osobiście w Sanoku, telefonicznie lub online.",
  },
  {
    step: "02",
    title: "Analiza ofert",
    description: "Przeszukuję i porównuję oferty wielu banków i instytucji finansowych, by znaleźć najlepsze dopasowanie do Twojej sytuacji.",
  },
  {
    step: "03",
    title: "Rekomendacja i wyjaśnienie",
    description: "Przedstawiam wybrane rozwiązanie w przystępny sposób – wyjaśniam warunki, koszty, harmonogram i wszystkie szczegóły.",
  },
  {
    step: "04",
    title: "Przygotowanie dokumentów",
    description: "Wspieram w kompletowaniu i przygotowaniu całej dokumentacji wymaganej przez wybrany bank.",
  },
  {
    step: "05",
    title: "Wniosek i decyzja",
    description: "Składam wniosek w Twoim imieniu i śledzę proces. Jestem w kontakcie na każdym etapie aż do decyzji kredytowej.",
  },
  {
    step: "06",
    title: "Podpisanie umowy",
    description: "Po pozytywnej decyzji pomagam w formalnym zakończeniu procesu – umowa, notariusz, wypłata środków.",
  },
];

export const trustItems = [
  { icon: "ri-bank-line", text: "Współpraca z wieloma bankami" },
  { icon: "ri-award-line", text: "Certyfikowany ekspert kredytowy" },
  { icon: "ri-time-line", text: "Ponad 25 lat doświadczenia" },
  { icon: "ri-user-smile-line", text: "Setki zadowolonych klientów" },
];

export const faqItems = [
  {
    question: "Czy korzystanie z usług eksperta kredytowego jest płatne?",
    answer: "Pierwsza konsultacja jest zawsze bezpłatna i niezobowiązująca. Ekspert kredytowy otrzymuje prowizję od banku w przypadku pozytywnego zakończenia procesu kredytowego, co oznacza, że klient nie ponosi bezpośrednich kosztów korzystania z usług.",
  },
  {
    question: "Jakie dokumenty są potrzebne do wniosku kredytowego?",
    answer: "Podstawowe dokumenty to dowód osobisty, zaświadczenie o dochodach (PIT, umowa o pracę, wyciąg z KPiR), dokumenty dotyczące nieruchomości (w przypadku kredytu hipotecznego) oraz potwierdzenie zatrudnienia. Dokładna lista zależy od rodzaju kredytu i sytuacji klienta – pomagam w kompletowaniu wszystkich potrzebnych dokumentów.",
  },
  {
    question: "Ile trwa proces uzyskania kredytu hipotecznego?",
    answer: "Czas zależy od banku i złożoności sytuacji. W przypadku kredytów hipotecznych proces zazwyczaj trwa od 2 do 6 tygodni, od momentu złożenia kompletnego wniosku do wypłaty środków. Kredyty gotówkowe są znacznie szybsze – często decyzja w ciągu kilku dni.",
  },
  {
    question: "Czy mogę skonsolidować kilka kredytów w jeden?",
    answer: "Tak, konsolidacja kredytów to jedna z oferowanych usług. Polega ona na zastąpieniu kilku miesięcznych rat jedną, zazwyczaj niższą ratą. Analizuję sytuację i pomagam wybrać najkorzystniejszą ofertę konsolidacji dostępną na rynku.",
  },
  {
    question: "Czy ekspert kredytowy reprezentuje konkretny bank?",
    answer: "Nie – jako niezależny ekspert kredytowy współpracuję z wieloma bankami i instytucjami finansowymi. Dzięki temu mogę przeanalizować szeroką gamę ofert i zaproponować rozwiązanie najlepiej dopasowane do sytuacji klienta, a nie do jednego produktu bankowego.",
  },
  {
    question: "Obsługujecie klientów spoza Sanoka?",
    answer: "Tak, obsługuję klientów z całego województwa podkarpackiego – Brzozów, Lesko, Krosno, Ustrzyki Dolne, Dynów, Zagórz, Bieszczady oraz okoliczne miejscowości. Konsultacje mogą odbywać się telefonicznie lub online, a spotkania osobiste mogą być zorganizowane w dogodnym miejscu.",
  },
];

export const testimonials = [
  {
    name: "Anna i Marek K.",
    location: "Sanok",
    text: "Pan Jan pomógł nam przejść przez cały proces kredytowy bez stresu. Wszystko było jasno wyjaśnione, a my dostaliśmy kredyt na znacznie lepszych warunkach, niż sami byliśmy w stanie znaleźć.",
  },
  {
    name: "Piotr S.",
    location: "Krosno",
    text: "Profesjonalne podejście, cierpliwość i rzetelna analiza. Ekspert kredytowy wyszukał ofertę, o której nawet nie wiedziałem. Polecam każdemu, kto szuka kredytu.",
  },
  {
    name: "Firma Budowlana Dach-Pol",
    location: "Brzozów",
    text: "Wsparcie w uzyskaniu kredytu inwestycyjnego dla firmy. Szybka analiza, konkretna rekomendacja i pełne wsparcie w dokumentacji. Doskonała współpraca.",
  },
];
